






































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { AgencyDashboardModule } from "@/store/modules/agencyDashboard";
import GiganautVue from "@/components/Shared/GiganautVue";
import ShiftBookedStatus from "@/components/Shifts/Display/ShiftBookedStatus.vue";
import BookingDateShiftSummary from '@/components/Shifts/RoleDateShiftSummary.vue';
import PageNames from "@/router/PageNames";
import BookingRoleStatisticsSearchCriteria from "@/components/BookingRoles/BookingRoleStatisticsSearchCriteria.vue";
import { AgencyModule } from "@/store/modules/agency";
import { AppModule } from "@/store/modules/app";

@Component({
  name: "DashboardBookingRoleStatistics",
  components: { ShiftBookedStatus, BookingDateShiftSummary, BookingRoleStatisticsSearchCriteria },
})
export default class DashboardBookingRolesWeekSummary extends GiganautVue {
  
  get loading() {
    return AgencyDashboardModule.loading;
  }

  get headers() {
    return AgencyDashboardModule.headers;
  }

  get bookingRoleWeeks() {
    return AgencyDashboardModule.bookingRoleWeekStatistics.bookingRoleWeeks;
  }

  get bookingRoleWeekStatistics() {
    return AgencyDashboardModule.bookingRoleWeekStatistics;
  }

  async navigateToBooking(bookingId: string) {
    window.open(window.location.origin + "/agency/bookings/" + bookingId);
  }

  async statusClicked() {
    
  }

  private expanded: [];
  private search = "";
}
